import { Navigate, Outlet } from 'react-router'
import { useCurrentUser } from '../../auth/userContext'

export default function ProtectedRoute() {
  const { user, loading } = useCurrentUser()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        Loading...
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
